import React from 'react';
import TablaInmuebles from '../components/rentas/tablaInmuebles';


function RengasInmo() {
  return (
      <div className='col-12 d-flex justify-content-center row p-0 m-0'>
        <TablaInmuebles />
      </div>
  );
}

export default RengasInmo;




// WEBPACK FOOTER //
// ./src/pages/inmuebles.js